export default __webpack_public_path__ + "static/media/sub-category-musicAndArts-musicStudio.44ced620.jpg";